import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

export function CheckoutSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending", metadata: {} });
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      if (attempts >= 8) { setError("Zahlungsstatus konnte nicht ermittelt werden."); return; }
      attempts += 1;
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        setStatus(r.data);
        if (r.data.payment_status === "paid" || r.data.status === "expired") return;
        setTimeout(poll, 2000);
      } catch (e) { setError(e.message); }
    };
    poll();
  }, [sessionId]);

  const slug = status.metadata?.tenant_slug;

  if (error) return <Center><div className="text-center"><XCircle size={56} weight="bold" className="mx-auto text-red-500" /><h1 className="font-heading text-3xl font-bold mt-4">Fehler</h1><p className="text-sm text-zinc-500 mt-2">{error}</p></div></Center>;

  if (status.payment_status === "paid") return (
    <Center>
      <div className="text-center max-w-md">
        <CheckCircle size={64} weight="bold" className="mx-auto" style={{ color: "var(--tenant-primary, #16A34A)" }} />
        <h1 className="font-heading text-4xl font-extrabold tracking-tight mt-4">Zahlung erfolgreich!</h1>
        <p className="text-zinc-500 mt-3">Vielen Dank für Ihre Buchung. Sie erhalten in Kürze eine Bestätigungs-E-Mail an <span className="font-medium text-black">{status.metadata?.customer_email}</span>.</p>
        <div className="bg-zinc-50 border border-black/10 rounded-md p-4 mt-6 text-left text-sm">
          <div className="flex justify-between"><span className="text-zinc-500">Betrag</span><span className="font-mono font-bold">€{(status.amount_total / 100).toFixed(2)}</span></div>
          <div className="flex justify-between mt-1"><span className="text-zinc-500">Paket</span><span className="font-medium">{status.metadata?.package_id}</span></div>
        </div>
        {slug && <Link to={`/portal/${slug}`}><Button className="mt-6 rounded-md text-white h-11 px-7" style={{ background: "var(--tenant-primary)" }} data-testid="checkout-back-home">Zurück zur Startseite</Button></Link>}
      </div>
    </Center>
  );

  return <Center><div className="text-center"><div className="inline-block h-12 w-12 border-2 border-black border-t-transparent rounded-full animate-spin" /><p className="mt-4 text-sm text-zinc-500">Zahlung wird verarbeitet…</p></div></Center>;
}

export function CheckoutCancel() {
  return (
    <Center>
      <div className="text-center max-w-md">
        <XCircle size={56} weight="bold" className="mx-auto text-zinc-400" />
        <h1 className="font-heading text-3xl font-bold mt-4">Abgebrochen</h1>
        <p className="text-zinc-500 mt-2">Ihre Buchung wurde nicht abgeschlossen. Sie können jederzeit erneut starten.</p>
        <Link to="/"><Button className="mt-6 rounded-md bg-black text-white hover:bg-zinc-800" data-testid="cancel-home">Zur Startseite</Button></Link>
      </div>
    </Center>
  );
}

const Center = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center bg-white px-6">{children}</div>
);
